import { createApiCall } from 'lib/base';

const makeCreateCall = (key: string, path: string) =>
  createApiCall<{ payload: any }>(key, ({ payload }) => ({
    endpoint: `api/admin/${path}`,
    method: 'POST',
    body: payload,
  }));

export const createIndustry = makeCreateCall(
  'CREATE_ICB_INDUSTRY',
  'stock-icb/industries'
);
export const createSuperSector = makeCreateCall(
  'CREATE_ICB_SUPERSECTOR',
  'stock-icb/supersectors'
);
export const createSector = makeCreateCall(
  'CREATE_ICB_SECTOR',
  'stock-icb/sectors'
);
export const createSubSector = makeCreateCall(
  'CREATE_ICB_SUBSECTOR',
  'stock-icb/subsectors'
);
